import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslocoRootModule } from 'src/app/transloco-root.module';

interface PasswordRule {
  key: 'lowercase' | 'uppercase' | 'number' | 'minLength';
  labelKey: string;
  test: (value: string) => boolean;
  met: boolean;
}

@Component({
  selector: 'app-password-strength-checklist',
  standalone: true,
  imports: [CommonModule, TranslocoRootModule],
  templateUrl: './password-strength-checklist.component.html',
  styleUrl: './password-strength-checklist.component.css',
})
export class PasswordStrengthChecklistComponent implements OnChanges {
  @Input() password: string | null = '';

  rules: PasswordRule[] = [
    { key: 'lowercase', labelKey: 'password.checklist.lowercase', test: (v) => /[a-z]/.test(v), met: false },
    { key: 'uppercase', labelKey: 'password.checklist.uppercase', test: (v) => /[A-Z]/.test(v), met: false },
    { key: 'number',    labelKey: 'password.checklist.number',    test: (v) => /\d/.test(v),    met: false },
    { key: 'minLength', labelKey: 'password.checklist.minLength', test: (v) => v.length >= 6,   met: false },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['password']) {
      const value = this.password ?? '';
      this.rules = this.rules.map((r) => ({ ...r, met: r.test(value) }));
    }
  }
}
